/* unplugin-vue-components disabled */import { render } from "./pictureAssembly.vue?vue&type=template&id=f47fda50&scoped=true"
import script from "./pictureAssembly.vue?vue&type=script&lang=js"
export * from "./pictureAssembly.vue?vue&type=script&lang=js"

import "./pictureAssembly.vue?vue&type=style&index=0&id=f47fda50&scoped=true&lang=css"

import exportComponent from "E:\\work\\weitu_land_page_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f47fda50"]])

export default __exports__